import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationGr from "./locales/gr/translation.json"
import translationEn from "./locales/eng/translation.json"
import translationAl from "./locales/al/translation.json"
import translationDe from "./locales/de/translation.json"
import translationEs from "./locales/es/translation.json"

// the translations
const resources = {
  gr: {
    translation: translationGr,
  },
  en: {
    translation: translationEn,
  },
  al: {
    translation: translationAl,
  },
  de: {
    translation: translationDe,
  },
  es: {
    translation: translationEs,
  },
}

const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en")
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
